let memberTypeClass = {
  "プレミアム会員":      "c-mbrico_prm",
  "ライト会員":          "c-mbrico_lit",
  "フェロー":            "c-mbrico_flw",
  "既存会員":            "c-mbrico_exmbr",
  "非会員（メルマガ）":   "c-mbrico_nombr",
  "BIT関係者":           "c-mbrico_bit"
}

$("#search-member-info").on("click", function(){
  $.ajax({
    type: "GET",
    url: "http://localhost:3000/member_info?name_like=" + $("input").val(),
    dataType: "json",
    success: function(result){
      let rows = result.map(function(result){
        return '<tr class="c-lst_tr">' +
                 '<td class="c-lst_td"><a class="c-lst_link" href="#">' + result.id + '</a></td>' +
                 '<td class="c-lst_td"><span class="' + memberTypeClass[result.type] + '">' + result.type + '</span></td>' +
                 '<td class="c-lst_td">' + result.name + '</td>' +
               '</tr>';
      })
      $("tbody.c-lst_tbody").html(rows);
    },
    error: function(result) {
      alert("会員情報の取得に失敗しました。");
    }
  });
});
